<template>
  <div class="p-2 bg-gray-50 rounded-md shadow-md">
    <div v-if="wait">
      <Spinner
        message="Loading..."
        :size="6"
      />
    </div>
    <div v-else>
      <ScheduleRequestControlPanel
        :showRequestData="showRequestData"
        :requestData="requestData"
        @runTask="runTask"
      />
    </div>
  </div>
</template>

<script>
import Spinner from '../../Spinner.vue'

import user from '../../../services/user/user.js'
import scheduleRequestControlPanelService from '../../../services/activeSync/scheduleRequestControlPanel.js'

import ScheduleRequestControlPanel from './ScheduleRequestControlPanel.vue'

export default {
  components: {
    Spinner,
    ScheduleRequestControlPanel,
  },
  props: {
    scheduleRequestId: Number,
    showRequestData: {
      type: Boolean,
      default: true,
    },
    wait: Boolean,
  },
  data() {
    return {
      requestData: undefined,
    }
  },
  methods: {
    runTask(taskType) {
      scheduleRequestControlPanelService.runTask(taskType, this.scheduleRequestId)
    },
    async init() {
      await user.ready()
      this.requestData = await scheduleRequestControlPanelService.getSingleRequest(this.scheduleRequestId)
    },
  },
  async mounted() {
    if (this.wait) {
      return
    }

    await this.init()
  },
  watch: {
    wait(newValue) {
      if (!newValue) {
        this.init()
      }
    },
  },
}
</script>
